import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { RecrystaMark } from "@/components/RecrystaLogo";

export default function ImprintPage() {
  return (
    <div className="min-h-screen w-full bg-slate-50 text-slate-900" data-testid="imprint-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <RecrystaMark size={32} />
            <span className="text-sm font-bold tracking-tight">Recrysta</span>
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900 inline-flex items-center gap-1">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12">
        <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500 font-semibold">Legal</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight">Imprint</h1>
        <p className="mt-2 text-sm text-slate-500">
          Placeholder — the definitive imprint (§5 TMG / §55 RStV) will be filled in with your
          registered company details before public launch.
        </p>

        <div className="mt-8 rounded-2xl bg-white border border-slate-200 p-6 space-y-4 text-[15px] leading-relaxed text-slate-700">
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">Publisher</div>
            <div className="mt-1 font-semibold text-slate-900">Recrysta (placeholder)</div>
            <div>Registered company name, form, and address to be added.</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">Contact</div>
            <div className="mt-1">
              Email: <a className="text-slate-900 underline" href="mailto:support@recrysta.com">support@recrysta.com</a>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">Responsible for content (§18 (2) MStV)</div>
            <div className="mt-1">Founding team — name to be added at launch.</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">Company registration</div>
            <div className="mt-1">Handelsregister / VAT ID to be added at launch.</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">Dispute resolution</div>
            <div className="mt-1">
              The EU Commission provides an online dispute resolution platform at{" "}
              <a className="text-slate-900 underline" href="https://ec.europa.eu/consumers/odr/">ec.europa.eu/consumers/odr</a>.
              We are not obligated and not willing to participate in a dispute resolution procedure
              before a consumer arbitration board.
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
